/*
  actielijst.js

  A local helper to form the final "Actielijst"
  into the grid as per design.

  Author: Tim Bauwens
  Copyright: xxllnc 2022

*/

import { bb } from "$json";
import { getCurrentChapterID } from "$json/lib/getcurrentchapterid";
import { getmetadata } from "$json/lib/getmetadata";
import { state } from "$json/lib/store";
import { CONFIG as scrollconfig } from "../../../../plugins/auto-scroll/auto-scroll";
import "./actielijst-widget.js";
((win, doc, $) => {
  let continueLink;

  function dateString(date, withdashes = false) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (String(month).length === 1) month = "0" + month;
    let day = date.getDate();
    if (String(day).length === 1) day = "0" + day;

    return withdashes ? `${year}-${month}-${day}` : `${year}${month}${day}`;
  }

  function UTCStamp(h = 0) {
    let now = new Date();
    now.setHours(h, 0, 0);
    return `T${now.getUTCHours()}000000Z`;
  }

  function msUTCStamp(h = 0) {
    // T12:00:00+00:00
    let now = new Date();
    now.setHours(h, 0, 0);
    return encodeURIComponent(`T${now.getUTCHours()}:00:00+00:00`);
  }

  function gglDate() {
    let target = new Date();
    target.setDate(target.getDate() + 3);
    let string = `${dateString(target)}${UTCStamp(12)}`;
    string += `/${dateString(target)}${UTCStamp(13)}`;
    string = encodeURIComponent(string);
    return string;
  }

  function datesStrings() {
    let target = new Date();
    target.setDate(target.getDate() + 3);
    let strings = {
      normal: dateString(target),
      dashes: dateString(target, true)
    };
    return strings;
  }

  function createHref(e) {
    // Useful: https://parcel.io/tools/calendar

    let href;

    const msgText = encodeURIComponent(`
    Deze reminder in je agenda leidt je terug naar de CyberVeilig Check van het Digital Trust Center.
    Vink af wat je gedaan hebt en check welke maatregelen je nog moet nemen om je beter te beschermen tegen cyberaanvallen.

    De link naar je eigen actielijst is:
    ${decodeURIComponent(continueLink)}

    Heb je vragen? Neem contact met ons op:
    digitaltrust@minezk.nl

    Veel succes,

    Team Digital Trust Center

    www.digitaltrustcenter.nl
    `);

    const msgTextICS = encodeURIComponent(
      `Deze reminder in je agenda leidt je terug naar de CyberVeiligCheck van het Digital Trust Center. Vink af wat je gedaan hebt en check welke maatregelen je nog moet nemen om je beter te beschermen tegen cyberaanvallen. De link naar je eigen actielijst is: ${decodeURIComponent(
        continueLink
      )} Heb je vragen? Neem contact met ons op: mailto:digitaltrust@minezk.nl?subject=Vraag%20over%20CyberVeilig%20Check Veel succes, Team Digital Trust Center www.digitaltrustcenter.nl`
    );
    const titleText = encodeURIComponent(`Doorgaan met de CyberVeiligCheck`);
    let strings = datesStrings();

    e.target.parentNode.querySelector("a.agenda").target = "_blank";

    switch (e.target.value) {
      case "none":
        href = "";
        break;

      case "google":
        //https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230119T110000Z%2F20230120T120000Z&details=ddddd&location=llll&text=ttttt
        href = `https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${gglDate()}&location=${continueLink}&details=${msgText}&text=${titleText}`;
        break;

      case "outlook":
        //https://outlook.live.com/calendar/0/deeplink/compose?body=ddddd&enddt=2023-01-20T12%3A00%3A00%2B00%3A00&location=llll&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2023-01-20T11%3A00%3A00%2B00%3A00&subject=ttttt
        href = `https://outlook.live.com/calendar/0/deeplink/compose?body=${msgText}&enddt=${
          strings.dashes
        }${msUTCStamp(
          13
        )}&location=${continueLink}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${
          strings.dashes
        }${msUTCStamp(12)}&subject=${titleText}`;
        break;

      case "office":
        //https://outlook.office.com/calendar/0/deeplink/compose?body=ddddd&enddt=2023-01-20T12%3A00%3A00%2B00%3A00&location=llll&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2023-01-20T11%3A00%3A00%2B00%3A00&subject=ttttt
        href = `https://outlook.office.com/calendar/0/deeplink/compose?body=${msgText}&enddt=${
          strings.dashes
        }${msUTCStamp(
          13
        )}&location=${continueLink}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${
          strings.dashes
        }${msUTCStamp(13)}&subject=${titleText}`;
        break;

      case "yahoo":
        //https://outlook.live.com/calendar/0/deeplink/compose?body=ddddd&enddt=2023-01-20T12%3A00%3A00%2B00%3A00&location=llll&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2023-01-19T11%3A00%3A00%2B00%3A00&subject=ttttt
        href = `https://calendar.yahoo.com/?desc=${msgText}&et=${
          strings.dashes
        }${msUTCStamp(13)}&in_loc=${continueLink}&st=${
          strings.dashes
        }${msUTCStamp(12)}&title=${titleText}&v=60`;
        break;

      case "ics":
        //data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0AVERSION:2.0%0ABEGIN:VEVENT%0ADTSTART:20230119T110000Z%0ADTEND:20230120T120000Z%0ASUMMARY:ttttt%0ADESCRIPTION:ddddd%0ALOCATION:llll%0AEND:VEVENT%0AEND:VCALENDAR%0A
        href = `data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0AVERSION:2.0%0ABEGIN:VEVENT%0ADTSTART:${
          strings.normal
        }${UTCStamp(12)}%0ADTEND:${strings.normal}${UTCStamp(
          13
        )}%0ASUMMARY:${titleText}%0ADESCRIPTION;ENCODING=QUOTED-PRINTABLE:${msgTextICS}%0ALOCATION:${continueLink}%0AEND:VEVENT%0AEND:VCALENDAR%0A`;
        e.target.parentNode.querySelector("a.agenda").target = "";
        break;

      default:
        href = "";
        break;
    }

    // Now set the href
    e.target.parentNode.querySelector("a.agenda").href = href;
    if (href !== "") {
      e.target.parentNode.querySelector("a.agenda").removeAttribute("tabindex");
    } else {
      e.target.parentNode
        .querySelector("a.agenda")
        .setAttribute("tabindex", "-1");
    }
  }

  function calanderInvites() {
    let html = `
      <button class="p-actielijst--agenda-header">
        <strong>Zet in mijn agenda</strong>
      </button>
      <div class="p-actielijst--agenda-content">
        <p>
          Plan hier tijd voor over 3 dagen:
        </p>
        <select aria-label="Selecteer kalendertype" class="href-selector">
          <option value="none">Selecteer kalendertype</option>
          <option value="ics">Desktop apps (ICS)</option>
          <option value="google">Google</option>
          <option value="outlook">Outlook (Web)</option>
          <option value="office">Office365</option>
          <option value="yahoo">Yahoo</option>
        </select>
        <a target="_blank" href="" tabindex="-1" class="agenda">
          Zet in mijn agenda
        </a>
      </div>
    `;
    return html;
  }

  $(doc).on("bb:finalHandleData", (_e, data) => {
    if (data && data.groups && data.groups.length) {
      const props = getmetadata(data).props;
      if (props.has("p-actielijst-show")) {
        bb.Mode.set("hasActielijst");
        // Break into the auto-scroll if needed:
        if (doc.querySelector(".bbm-deel-2")) {
          scrollconfig.props = { selector: ".bbm-deel-2" };
        } else {
          scrollconfig.props = "default";
        }
        // Store the chapterID for the jump back button
        let saved = state.has("p-chapters-helper")
          ? state.get("p-chapters-helper")
          : {};
        saved.actielijstID = getCurrentChapterID(data.groups);
        state.set("p-chapters-helper", saved);

        // Grab some values for continue later link in agenda:
        const location = bb.propFinder(bb.conf)(
          "arbitrary.savecase-email-link-popup.location",
          window.location.href
        );
        const sessionid = data.sessionid;
        continueLink = encodeURIComponent(
          `${location}?modelid=${data.dbname}&sessionid=${sessionid}`
        );
        try {
          // Move some things arround in the DOM to support the design.
          let fieldset = doc.querySelector("#bb-q fieldset");
          let legend = fieldset.querySelector("legend");
          let text = fieldset.querySelector(".bb-text");
          let toggler = fieldset.querySelector(
            '[data-metadata-keys="expanderToggle"]'
          );
          let togglerText = fieldset.querySelector(
            '[data-metadata-keys="expanderText"]'
          );
          let download = fieldset.querySelector('a[type="application/pdf"]');
          let newContainer = doc.createElement("div");
          newContainer.className = "p-actielijst-head";
          newContainer.innerHTML = `
            <div class="content">
              ${legend.outerHTML}
              ${text.outerHTML}
              <input id="toggler" type="checkbox" class="a-offscreen" />
              <label for="toggler">${toggler.outerHTML}</label>
              ${togglerText.outerHTML}
            </div>
            <div class="btns">
              ${download.outerHTML}
              <button 
                href="${continueLink}"
                aria-haspopup="dialog"
                class="continue p-savecase-email-link-popup-button">
                  Ga later verder
              </button>
              ${calanderInvites()}
            </div>
          `;
          fieldset.removeChild(legend);
          fieldset.removeChild(text);
          fieldset.removeChild(toggler);
          fieldset.removeChild(togglerText);
          fieldset.removeChild(download);
          fieldset.prepend(newContainer);
          let clonebtns = doc.querySelector(".btns").cloneNode(true);
          clonebtns.classList.add("final");
          clonebtns.querySelector('a[type="application/pdf"]').id = "";
          fieldset.append(clonebtns);
          doc.querySelectorAll("select.href-selector").forEach(select => {
            select.addEventListener("change", createHref);
          });
          doc
            .querySelectorAll(".btns:not(.final) .p-actielijst--agenda-header")
            .forEach(agenda => {
              agenda.addEventListener("click", _e => {
                bb.Mode.toggle("showAgendaAdd");
              });
            });
        } catch (err) {
          win.console && win.console.warn(err);
        }
        // Add some mis recording for clicks on add to agenda...
        let recorder = doc.querySelector(
          'input[data-metadata-keys^="p-mis-click-count-agenda-field"]'
        );

        if (recorder) {
          recorder.closest(".bb-questionlabelgroup").style.display = "none";
          doc
            .querySelectorAll(".p-actielijst--agenda-content a.agenda")
            .forEach(btn => {
              btn.addEventListener("click", _e => {
                try {
                  recorder.value = "true";
                  bb.updatemis();
                } catch (err) {
                  window.console && window.console.warn(err);
                }
              });
            });
        }

        // In case this is "deel 2", scroll the user to the start of that chapter.
        // if (
        //   doc.querySelector("body").dataset["node"] ===
        //   "gresultaat.resultaat"
        // ) {
        //   console.log("yes");
        //   let title = doc.querySelector('.bbm-foo');
        //   // title.scrollIntoView({ behavior: "smooth", block: "start" })
        // }
      } else {
        bb.Mode.unset("hasActielijst");
      }
    }
  });
})(window, document, jQuery);
